import { useRouteLoaderData } from 'react-router';

import type { loader } from '@/root';

export const useRootLoaderData = () => {
  return useRouteLoaderData<typeof loader>('root')!;
};
